/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable react/prop-types */
import React from 'react';

import { useTranslation } from 'react-i18next';

import { CrossIconSymbol, SearchIconSymbol } from 'styles/assets/icons';

import styles from './index.module.scss';

const SearchBox = React.forwardRef(
  (
    {
      onSearchChange,
      searchValue,
      clearSearch,
      placeholder,
      headerInputStyles,
      id,
      showBackSlash,
      crossIconClassName,
      className,
      ...props
    },
    ref
  ) => {
    const { t } = useTranslation(['common']);

    return (
      (<div
        className={`${styles['search-wrapper']} ${className || ''}`}
        data-palette="SearchBox">
        <div className={styles['icon-wrapper']}>
          <SearchIconSymbol className={styles['search-icon']} />
        </div>
        <input
          // autoFocus={!isMobileOrTablet()}
          data-testid="search-input"
          autoFocus
          id={id || 'searchInput'}
          className={`${styles['header-input']} ${headerInputStyles || ''} ${
            className || ''
          }`}
          type="text"
          placeholder={placeholder || t('common:search')}
          onChange={e => onSearchChange(e.target.value)}
          ref={ref}
          autoComplete="off"
          value={searchValue}
          {...props}
        />
        {searchValue !== '' ? (
          <div
            data-testid="cross-icon"
            aria-hidden="true"
            data-cy="cross"
            className={`${styles['cross-icon']} ${styles[crossIconClassName]}`}
            onClick={clearSearch}
            data-palette="SearchBox">
            <CrossIconSymbol color="#717782" />
          </div>
        ) : showBackSlash ? (
          <div className={styles['backslash-container']} data-palette="SearchBox">/</div>
        ) : null}
      </div>)
    );
  }
);

export default SearchBox;
